<template>
  <div class="">
    <headerbox></headerbox>

    <div class="main">
      <hotelhead></hotelhead>

      <div class="container">
        <div class="layout">
          <menuTitle :titles="lefttitles"></menuTitle>
          <div class="hotelservices">
            <dl v-if="hotelinfro && hotelinfro.service">
              <dt>酒店服务</dt>
              <dd>{{ hotelinfro.service }}</dd>
            </dl>
            <dl v-if="hotelinfro && hotelinfro.kaiye">
              <dt>开业时间</dt>
              <dd>{{ hotelinfro.kaiye }}</dd>
            </dl>
            <dl v-if="hotelinfro && hotelinfro.yulejianshen">
              <dt>娱乐健身</dt>
              <dd>{{ hotelinfro.yulejianshen }}</dd>
            </dl>

            <dl v-if="hotelinfro && hotelinfro.canyin">
              <dt>酒店餐饮</dt>
              <dd>{{ hotelinfro.canyin }}</dd>
            </dl>
            <dl v-if="hotelinfro && hotelinfro.jianshu">
              <dt>酒店提示</dt>
              <dd>{{ hotelinfro.jianshu }}</dd>
            </dl>
            <dl>
              <dt>支付方式</dt>
              <dd>
                <img src="@/assets/images/pay1.png" alt="" />
                <img src="@/assets/images/pay2.png" alt="" />
                <img src="@/assets/images/pay3.png" alt="" />
                <img src="@/assets/images/pay4.png" alt="" />
                <img src="@/assets/images/pay5.png" alt="" />
                <img src="@/assets/images/pay6.png" alt="" />
              </dd>
            </dl>
          </div>
        </div>
        <div class="sides">
          <menuTitle :titles="righttitles"></menuTitle>
          <leftcheck></leftcheck>
        </div>
      </div>
    </div>
    <footerbox></footerbox>
  </div>
</template>

<script>
import footerbox from "components/content/footer";
import headerbox from "components/content/header";
import hotelhead from "components/content/hotelhead";
import leftcheck from "components/content/Leftcheck";
import menuTitle from "components/content/menuTitle";
export default {
  name: "Services",

  components: {
    footerbox,
    headerbox,
    hotelhead,
    leftcheck,
    leftcheck,
    menuTitle,
  },

  data() {
    return {
      righttitles: "在线酒店查询",
      lefttitles: "酒店服务",
    };
  },
  methods: {},
  computed: {
    hotelinfro() {
      // 从Vuex中获取房间信息
      let roomInfo = this.$store.state.hotelinfro;

      // 如果Vuex中没有房间信息，则从LocalStorage中获取
      if (!roomInfo) {
        const localStorageRoomInfo = localStorage.getItem("hoteldata");
        if (localStorageRoomInfo) {
          roomInfo = JSON.parse(localStorageRoomInfo);
        }
      }

      return roomInfo;
    },
  },
};
</script>
<style lang="less" scoped>
.hotelservices {
  dl {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 40px;
    line-height: 24px;
    dt {
      font-weight: bold;
      width: 60px;
      text-align: right;
      padding-right: 10px;
      color: #222;
    }
    dd {
      flex: 10;
      color: #555;
      display: flex;
      justify-content: flex-start;
      img {
        margin-right: 10px;
      }
    }
  }
}

@media (min-width: 320px) and (max-width: 780px) {
  .hotelservices {
    dl dd {
      flex-wrap: wrap;
      img{
        width: 15%;
        margin-bottom: 20px;
      }
    }
  }
}
</style>
